const dsMixed = (($) => {

    const base_url = 'index.php?route=account/mixed_box_prefs/',
        modal = 'div#mixed-box-preferences-modal',
        tab= 'permanent';

    function search(el) {
        const view = dsUtilities.getView(el),
            tab = $(el).closest('div[data-tab]').attr('data-tab'),
            input_div = view === 'account' ? 'input.mixed-box-preferences' : `input#${tab}-input`,
            results_div = view === 'account' ? 'div.mixed-results' : `div#${tab}-search-results`,
            button_preferred = view === 'account' ? 'button.preferred' : `div#${tab}-preferences button.preferred`,
            button_dislike = view === 'account' ? 'button.dislike' : `div#${tab}-preferences button.dislike`,
            request = $(input_div).val().trim();
        let html = '';
        if (request.length > 2) {
            $(results_div).html('');
            autocomplete(request).done(function(response) {
                const results = response.results;
                if (response.success && results.length > 0) {
                    results.forEach(function(result) {
                        html += htmlItem(result);
                    });
                    $(input_div).addClass('mixed-box-preferences-expand');
                    $(results_div).html(html);
                    const divs = {'results': results_div, 'input': input_div};
                    $(button_preferred).each(function(i) { $(this).click(function() { add(divs , 'like', results[i], view); }); });
                    $(button_dislike).each(function(i) { $(this).click(function() { add(divs, 'dislike', results[i], view); }); });
                    $(results_div).fadeIn(300);
                }
            });
        }
    }

    function autocomplete(request) {
        return $.ajax({
            url: base_url + 'autocomplete',
            type: 'post',
            data: { request: request },
            dataType: 'json'
        });
    }

    function htmlItem(data) {
        return `<div class="auto-complete-item">
            <span class="mb-tooltip">${data.name}<span class="mb-tooltiptext">${data.hover}</span></span>
            <button class="green-btn circle preferred"><img src="/dist/images/tick.svg" /></button>
            <button class="red-btn circle dislike"><img src="/dist/images/remove_white.svg" /></button>
        </div>`;
    }

    function add(divs, type, item, view) {
        $(divs.results).fadeOut(300);
        $(divs.input).removeClass('mixed-box-preferences-expand').val('').attr('placeholder', 'Eg. Apples');
        ajax_add(type, item).done(function (response) {
            if (response.success) {
                const button = type === 'dislike' ? '-orange' : '',
                    hover = item.hover.length > 0;
                $(view ==='account' ? `div#mixed-${type}-content` : `div#${tab}-${type}-content`).append(
                    `<button class="btn clear-btn${button}${hover ? ' mb-tooltip' : ''}" data-type="${type}" data-id="${item.gid}">${item.name}${hover ? `<span class="mb-tooltiptext">${item.hover}</span>` : ''}<span class="remove-preference"></span></button>`
                );
            }
        });
    }

    function ajax_add(type, item) {
        return $.ajax({
            url: base_url + 'add',
            type: 'post',
            data: { type: type, id: item.gid, name: item.name },
            dataType: 'json'
        });
    }

    function remove(el, type, id) {
        const view = dsUtilities.getView(el);
        ajax_remove(type, id).done(function (response) {
            if (response.success) {
                $(el).fadeOut('slow', function () {
                    $(this).remove();
                });
                const div_content = view === 'account' ? `div#mixed-${type}-content button.clear-btn` : `div#${area}-${type}-content button.clear-btn`;
            }
        });
    }

    function ajax_remove(type, id) {
        return $.ajax({
            url: base_url + 'remove',
            type: 'post',
            data: { type: type, id: id },
            dataType: 'json'
        });
    }

    function ajax_prefs() {
        return $.ajax({
            url: base_url + 'prefs',
            type: 'post',
            dataType: 'json'
        });
    }

    function modalTab() {
        if (!doorstep.logged_in) {
            $(`div#${tab}-preference-list`).html('You are not logged in');
            $(`${modal} div.search-form, ${modal} label.checkmark-item`).addClass('hide');
        } else {
            $(`${modal} div.search-form, ${modal} label.checkmark-item`).removeClass('hide');
            modalPrefs();
        }
    }

    function modalPrefs() {
        ajax_prefs().done(function (response) {
            if (response.success) {
                $('div#permanent-preference-list').html(modalPrefsHTML(response));
            }
        });
    }

    function modalOpen() {
        $(modal).removeClass('hide');
        modalTab();
    }

    function modalClose() {
        $(modal).addClass('hide');
    }

    function modalPrefsHTML(response) {
        let html = '<div class="preference-list">';
        html += `<div class="preferred">
<img src="/dist/images/tick.svg" /><span style="font-size:.812rem;">Preferred</span></div><div class="preferred" id="${tab}-like-content">`;
        response.prefs.likes.forEach(function (item) {
            const aName = item.name.split('|'),
                hover = aName[1].length > 0;
            html += `<button class="btn clear-btn${hover ? ' mb-tooltip' : ''}" data-type="like" data-id="${item.id}">${aName[0]}${hover ? `<span class="mb-tooltiptext">${aName[1]}</span>` : ''}<span class="remove-preference"></span></button>`;
        });
        html += `</div><div class="disliked margin-1-top">
<img src="/dist/images/remove_orange.svg" /><span style="font-size:.812rem;">Disliked</span></div><div class="preferred" id="${tab}-dislike-content">`;
        response.prefs.dislikes.forEach(function (item) {
            const aName = item.name.split('|'),
                hover = aName[1].length > 0;
            html += `<button class="btn clear-btn-orange${hover ? ' mb-tooltip' : ''}" data-type="dislike" data-id="${item.id}">${aName[0]}${hover ? `<span class="mb-tooltiptext">${aName[1]}</span>` : ''}<span class="remove-preference"></span></button>`;
        });
        html += '</div></div>';
        return html;
    }

    $(document).ready(function () {

       $('input.mixed-box-preferences').keyup(function() {
           search(this);
       });

        $(document).on('click', 'div.preference-list button.clear-btn, div.preference-list button.clear-btn-orange', function() {
            remove(this, $(this).data('type'), $(this).data('id'));
        });

        $('button.mixed-close').on('click', function () {
            modalClose();
        });

    });

    return {
        modalOpen : modalOpen
    }

})(jQuery);